import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ConfirmationService, LazyLoadEvent, MessageService, PrimeNGConfig} from 'primeng/api';
import {validateSpaces} from 'src/app/util/custom.validator';
import {Constant} from '../util/constant';
import {SharedService} from '../web-services/shared.service';
import {ConstantService} from '../web-services/constant.service';
import {Labels} from '../util/labels';
import {AppointmentTypeService} from '../web-services/appointment-type.service';

declare var closeAddOverlaydiv: Function;
declare var closeSearchOverlaydiv: Function;
declare var openAddOverlaydiv: Function;

@Component(
    {selector: 'app-appointment-type', templateUrl: './appointment-type.component.html', styleUrls: ['./appointment-type.component.css']})
export class AppointmentTypeComponent implements OnInit {
    public labels = Labels;
    formButton: string = this.translate(this.labels.btnAdd);
    submitted = false;
    selectedIndex = -1;
    updateAppointmentTypeId = null;
    appointmentTypeList: any = [];
    appointmentTypeSearch: FormGroup;
    clearSearchBtn = false;
    totalRecords;
    itemPerPage: number = Constant.ITEM_PER_PAGE;
    appointmentTypeForm: FormGroup;
    constantList = [];
    pageNo: number = 0;
    onValueChange = true;

    showSearchDialog = false;
    showSearchBtn = false;
    showAddDialog = false;
    showAddBtn = false;
    editTag = false;
    disableColumn = false;
    passwordType = 'password';

    addEditTitle = '';
    constructor(
        private appointmentTypeServices: AppointmentTypeService, private primengConfig: PrimeNGConfig,
        private confirmation: ConfirmationService, private messageService: MessageService, private route: Router,
        private loader: NgxUiLoaderService, private constantService: ConstantService, private sharedService: SharedService
    ) {
    };

    get addUpdateTitle() {
        return this.updateAppointmentTypeId == null ? this.translate(this.labels.btnAdd) : this.translate(this.labels.btnUpdate);
    }

    onClearSearch() {
        this.appointmentTypeSearch.reset();
        this.selectedIndex = -1;
    }

    onSearch() {
        this.clearSearchBtn = true;
        this.countAppointmentType();
        this.findAllAppointmentType();
        closeSearchOverlaydiv();
    }

    startLoader() {
        this.loader.start();
        setTimeout(() => {
            this.loader.stop();
        }, 3000);
    }

    stopLoader() {
        this.loader.stop();
    }

    countAppointmentType() {
        this.appointmentTypeServices.countAppointmentType(this.appointmentTypeSearch.value).subscribe(res => {
            if (res['message'] == 'Success') {
                this.totalRecords = res['data'][0];
                this.findAllAppointmentType();
            } else {
                this.totalRecords = 0;
            }
        }, err => {
            console.error('err: ', err);
        });
    }

    onSubmit() {
        this.addUpdateAppointmentType(this.appointmentTypeForm.value);
        this.submitted = false;
        this.onClearAdd();
    }

    onPageChnage(event: LazyLoadEvent) {
        this.itemPerPage = event.rows;
        this.pageNo = event.first / event.rows;
        this.findAllAppointmentType();
    }

    clearSearchResult() {
        this.clearSearchBtn = false;
        this.appointmentTypeSearch.reset();
        this.countAppointmentType();
        // this.findAllAppointmentType();
    }

    addUpdateAppointmentType(appointmentType) {
        this.startLoader();
        if (this.updateAppointmentTypeId == null) {
            this.appointmentTypeServices.addAppointmentType(this.appointmentTypeForm.value).subscribe(res => {
                if (res['message'] == 'Success') {
                    appointmentType = res['data'][0];
                    this.appointmentTypeList.push(appointmentType);
                    this.messageService.add({
                                                severity: 'success',
                                                summary: this.translate(this.labels.btnAdd),
                                                detail: this.translate(this.labels.entityNameAppointmentType)
                                            });
                    this.submitted = true;
                    this.showHideAddDialog();
                    this.countAppointmentType();
                } else {
                    console.error(res['documentation']);
                    this.stopLoader();
                }
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
        } else {
            appointmentType.appointmentTypeId = this.updateAppointmentTypeId;
            this.appointmentTypeServices.updateAppointmentType(appointmentType).subscribe(res => {
                if (res['message'] == 'Success') {
                    this.appointmentTypeList[this.selectedIndex] = res['data'][0];
                    this.submitted = true;
                    this.messageService.add({
                                                severity: 'success',
                                                summary: this.translate(this.labels.btnUpdate),
                                                detail: this.translate(this.labels.entityNameAppointmentType)
                                            });
                    this.showSearchBtn = false;
                    this.showAddBtn = false;
                    this.showSearchDialog = false;
                    this.showAddDialog = false;
                    this.editTag = false;
                    this.countAppointmentType();
                } else {
                    console.error(res['documentation']);
                    this.stopLoader();
                }
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
            this.updateAppointmentTypeId = null;
            this.onClearAdd();
            this.formButton = this.translate(this.labels.btnAdd);
        }
        // this.stopLoader();
    }

    translate(label) {
        return this.sharedService.verifyLabel(label, this.constantList);
    }

    getConstantList(formId) {
        this.constantService.getFormConstantsList(formId).subscribe(data => {
            if (data['statusCode'] == 200) {
                this.constantList = data['data'];
            } else {
                this.constantList = [];
            }
        });
    }

    ngOnInit() {
      alert('here');
        this.addEditTitle = this.labels.btnAdd;
        this.appointmentTypeForm = new FormGroup({
                                                     appointmentType: new FormControl('', [Validators.required, validateSpaces]),
                                                     userId: new FormControl(0, [Validators.required, Validators.min(0)]),
                                                 });
        this.appointmentTypeSearch = new FormGroup({appointmentType: new FormControl(), userId: new FormControl(),});
        this.countAppointmentType();
        this.findAllAppointmentType();
        this.getConstantList(1234);
        this.primengConfig.ripple = true;
        this.clearSearchBtn = false;
        this.appointmentTypeSearch.valueChanges.subscribe(data => {
            this.onValueChange = false;
        });
    }

    findAllAppointmentType() {
        this.startLoader();
        this.appointmentTypeServices.findAllAppointmentType(this.appointmentTypeSearch.value, this.pageNo, this.itemPerPage).subscribe(
            res => {
                if (res['message'] == 'Success') {
                    this.appointmentTypeList = res['data'];
                } else {
                    this.appointmentTypeList = [];
                }
                this.stopLoader();
            }, err => {
                console.error('err: ', err);
                this.stopLoader();
            });
    }

    deleteByIdAppointmentType(appointmentTypeId: number, index) {
        this.confirmation.confirm({
                                      message: this.translate(this.labels.DELETE_MSG), accept: () => {
                this.startLoader();
                this.appointmentTypeServices.deleteByIdAppointmentType(appointmentTypeId).subscribe(res => {
                    if (res['message'] == 'Success') {
                        this.appointmentTypeList.splice(index, 1);
                        this.messageService.add({
                                                    severity: 'warn',
                                                    summary: this.translate(this.labels.entityNamePatients) +
                                                        this.translate(this.labels.deletedSuccessfully),
                                                    detail: ''
                                                });
                        this.countAppointmentType();
                    } else {
                        console.error('error: ', res['documentation']);
                        this.startLoader();
                    }
                }, err => {
                    console.error('err: ', err);
                    this.stopLoader();
                });
            }
                                  });
    }

    loadAppointmentTypeToEdit(appointmentTypeId: number, index) {
        let appointmentType = this.appointmentTypeList.find(x => x['appointmentTypeId'] == appointmentTypeId);
        this.submitted = null;
        this.formButton = this.translate(this.labels.btnEdit);
        this.updateAppointmentTypeId = appointmentType['appointmentTypeId'];
        this.selectedIndex = index;
        this.appointmentTypeForm.controls['appointmentType'].setValue(appointmentType['appointmentType']);
        this.appointmentTypeForm.controls['userId'].setValue(appointmentType['userId']);
        openAddOverlaydiv();
    }

    onClearAdd() {
        this.appointmentTypeForm.reset();
        this.appointmentTypeForm.markAsUntouched();
        this.updateAppointmentTypeId = null;
        closeAddOverlaydiv();
    }

    fieldReset(control) {
        return this.appointmentTypeForm.get(control).reset();
    }

    diplayeIconInField(control) {
        return this.appointmentTypeForm.get(control)?.valid;
    }

    inputFieldDanger(control) {
        return !this.appointmentTypeForm.get(control)?.valid && this.appointmentTypeForm?.get(control)?.touched;
    }

    onCloseAdd() {
        closeAddOverlaydiv();
        this.appointmentTypeForm.reset();
    }

    onCloseSearch() {
        closeSearchOverlaydiv();
        this.appointmentTypeSearch.reset();
    }

    refresh() {
        this.countAppointmentType();
    }

    onAddOverlayDiv() {
        openAddOverlaydiv();
        this.appointmentTypeForm.reset();
    }
    // by ali
    showHideSearchDialog() {
        this.showSearchDialog = !this.showSearchDialog;
        this.showSearchBtn = this.showSearchDialog;
        this.showAddBtn = this.showSearchDialog;
    }

    showHideAddDialog() {
        if(!this.showAddDialog) {
            this.appointmentTypeForm.reset();
        }
        this.addEditTitle = this.labels.btnAdd;
        this.showAddDialog = !this.showAddDialog;
        this.showAddBtn = this.showAddDialog;
        this.showSearchBtn = this.showAddDialog;
        this.editTag = false;
        this.updateAppointmentTypeId = null;
    }
}
